module.exports = __webpack_public_path__ + "img/logop3.50e62cbc.png";